<template>
  <div v-if="!isBlocked" class="materials-download mb-4">
    <div v-if="newArticleDetailsDisplay && hasVideo">
      <div class="materials-download__title mt-5 pb-3 mb-1 mr-2">
        <h2 class="title">Video</h2>
      </div>
      <div class="mr-2 mt-3">
        <AssetDisplay
          :item="article"
          :asset="article.asset"
          :autoplay="autoplay"
          :video-usage="videoUsage"
          video-event="DL-OR"
        />
      </div>
    </div>
    <div v-if="!newArticleDetailsDisplay">
      <div
        v-if="hasAsset"
        class="materials-download__title mt-5 pb-3 mb-1 mr-2"
      >
        <h2 class="title">Content</h2>
      </div>
      <div class="mr-2 mt-3">
        <AssetDisplay
          :item="article"
          :asset="article.asset"
          :autoplay="autoplay"
          :video-usage="videoUsage"
          video-event="DL-OR"
          :data-test-id="dataTestId"
        />
      </div>
    </div>
    <div
      v-if="hasSupplementaryAssets"
      class="materials-download__title mt-5 pb-3 mb-1 mr-2"
    >
      <h2 class="title">Supplementary materials</h2>
    </div>
    <div class="mr-2 mt-0">
      <AssetTableDisplay
        v-if="hasSupplementaryAssets && newArticleDetailsDisplay"
        :assets="article.supplementaryAssets"
      />
      <div
        v-for="(supplementary, index) in article.supplementaryAssets"
        v-else
        :key="index"
        class="materials-download__asset-container pl-2"
      >
        <AssetDisplay
          :item="article"
          :asset="supplementary.asset"
          :supplementary-title="supplementary.title"
          small
          video-usage
          video-event="DL-SM"
        />
        <div class="subtitle-1 mt-2">{{ supplementary.title }}</div>
        <div class="caption">{{ supplementary.description }}</div>
      </div>
    </div>

    <div
      v-if="hasSupplementaryWeblinks"
      class="materials-download__title mt-5 pb-3 mb-1 mr-2"
    >
      <h2 class="title">Supplementary weblinks</h2>
    </div>
    <div class="mr-2 mt-0">
      <WeblinkTableDisplay
        v-if="hasSupplementaryWeblinks && newArticleDetailsDisplay"
        :weblinks="article.supplementaryWeblinks"
      />
      <div
        v-for="(weblink, index) in article.supplementaryWeblinks"
        v-else
        :key="index"
        class="mr-2 mt-3"
      >
        <WeblinkDisplay :weblink="weblink" />
      </div>
    </div>
  </div>
</template>

<script>
import mapFlags from "~/plugins/utilities/mapFlags";

import AssetDisplay from "~/components/articles/components/AssetDisplay.vue";
import WeblinkDisplay from "~/components/articles/components/WeblinkDisplay.vue";
import WeblinkTableDisplay from "~/components/articles/components/WeblinkTableDisplay.vue";
import AssetTableDisplay from "~/components/articles/components/AssetTableDisplay.vue";

export default {
  name: "MaterialsDownload",
  components: {
    AssetDisplay,
    WeblinkDisplay,
    WeblinkTableDisplay,
    AssetTableDisplay,
  },
  props: {
    article: { type: Object, required: true },
    autoplay: { type: Boolean, default: false },
    videoUsage: { type: Boolean, default: false },
    dataTestId: {
      type: [String, null],
      default: null,
    },
  },
  computed: {
    ...mapFlags(["newArticleDetailsDisplay"]),

    hasVideo() {
      return this.article.asset?.mimeType?.includes("video");
    },
    hasAsset() {
      return this.article.asset?.original
        ? this.article.asset.original.url !== undefined
        : false;
    },
    hasSupplementaryAssets() {
      return this.article.supplementaryAssets
        ? this.article.supplementaryAssets.length > 0
        : false;
    },
    hasSupplementaryWeblinks() {
      return this.article.supplementaryWeblinks
        ? this.article.supplementaryWeblinks.length > 0
        : false;
    },
    isBlocked() {
      return this.article.blocked;
    },
  },
};
</script>

<style lang="scss" scoped>
.materials-download {
  &__title {
    border-bottom: solid 2px var(--v-softened-base);
  }

  &__asset-container {
    position: relative;
  }
}
</style>
